import "./orderProductRow.css"

export function OrderProductRow({ product, orderId }) {
    return (
        <table className="order-product-table">
            <tbody>
                <tr className="mt-3">
                    <td>
                        <div className="d-flex align-items-center ps-3 gap-3">
                            <div className="d-flex align-items-center admin-product-image">
                                <img src={product.image} width={30} alt="" />
                            </div>
                            <div className="admin-product-title">{product.title}</div>
                        </div>
                    </td>
                    <td>{orderId}</td>
                    <td>{product.quantity}</td>
                    <td>${product.salePrice ? product.salePrice : product.regularPrice}</td>
                </tr>
            </tbody>
        </table>
    )
}